module.exports = __webpack_public_path__ + "media/images/landing/persons/jiri-fabian-c2eb60e7f5a4bf1ae306691b2fa56a14.jpg";